import { MigrationUsersSummary } from './../../_models/MigrationUsersSummary';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserTemplates } from './../../_models/UserTemplates';
import { UserTemplatesService } from './../../_services/UserTemplates/UserTemplates.service';
import { PreloaderService } from './../../_services/Preloader.service';
import { MigrationServiceService } from './../../_services/_MigrationService/MigrationService.service';
import { Observable, fromEventPattern, Subscription, interval } from 'rxjs';

import { HttpClient, HttpResponse } from '@angular/common/http';

import { User } from './../../_models/User';
import { Component, OnInit, ViewChild } from '@angular/core';


import { Device } from 'src/app/_models/Device';
import { _userServicesService } from 'src/app/_services/_UserService/_userServices.service';
import { DeviceService } from 'src/app/_services/_DeviceService/Device.service';
import { ToasterService } from 'src/app/_services/Toaster.service';
import { not } from '@angular/compiler/src/output/output_ast';
import { createHostListener } from '@angular/compiler/src/core';




declare var $: any;
@Component({
   selector: 'app-Migration',
   templateUrl: './Migration.component.html',
   styleUrls: ['./Migration.component.css']
})

export class MigrationComponent implements OnInit {

   dataTable = false;
   SummaryTogle=false;
   MigrationSummary:MigrationUsersSummary;
   selectedDeviceFrom: string;
   //selectedDeviceTo: string;
   Device: Device[];
   SaveDevice: Device[];
   public Users: User[];
   isChecked = false;
   UserIDList: Array<string> = [];
   UserTemplates: UserTemplates[];
   private updateSubscription: Subscription;
   Progress:any;
   selectedDeviceTo: any;







   constructor(private Spinner:NgxSpinnerService, private UTemplates: UserTemplatesService, private preloader: PreloaderService, private MigrationService: MigrationServiceService, private DeviceService: DeviceService, private UserService: _userServicesService, private noti: ToasterService) {   console.clear();}


   ngOnInit(): void {
try {

  this.LoadSavedDevices();
  this.LoadActiveDevices();
  this.preloader.hide();
  console.clear();
} catch (error) {
  this.preloader.hide();
console.clear();

}


   }

   CheckUser(event, UserID) {
      if (event.target.checked) {
         //var ID = Number.parseInt(UserID);
         this.UserIDList.push(UserID);
      }
      else {
         const index = this.UserIDList.indexOf((UserID));
         if (index > -1) {
            this.UserIDList.splice(index, 1);
         }
      }
   }

   checkuncheckall() {
      if (this.isChecked == false) {
         this.isChecked = true;
         this.UserIDList = [];
         this.UserTemplates.forEach(item => {
            this.UserIDList.push((item.userId))
         });

      }
      else {
         this.isChecked = false;
         this.UserIDList = [];

      }
   }


   selectChangeHandlerDeviceFrom(event: any) {
      this.selectedDeviceFrom = event.target.value;
      this.LoadAllUser(this.selectedDeviceFrom);
   }

  //  selectChangeHandlerDeviceTo(event: any) {
  //     this.selectedDeviceTo = event.target.value;
  //  }

   LoadSavedDevices() {
      this.Spinner.show();
      try {
         this.UTemplates.GetDeviceList().subscribe(
            Response => {
               this.Spinner.hide();

               if (Response.status == 200) {
                  this.SaveDevice = Response.body;
                  console.clear();

               }
               else {
                  this.noti.error("Error", Response.body);
               }

            },
            err => {
               this.Spinner.hide();
               this.noti.error("Error", err.error);
            }
         );
      } catch (error) {
         this.Spinner.hide();
         this.noti.error("Error", "Code Crashed");
      }
   }

   LoadActiveDevices() {
      this.Spinner.show();
      try {
         this.DeviceService.GetActiveDeviceList().subscribe(
            Response => {
               this.Spinner.hide();
               console.clear();
               if (Response.status == 200) {
                  this.Device = Response.body;
                  this.selectedDeviceTo = this.Device[0];

               }
               else {
                  this.noti.error("Error", Response.body);
               }

            },
            err => {
               this.Spinner.hide();
               this.noti.error("Error", err.error);
            }
         );
      } catch (error) {
         this.Spinner.hide();
         this.noti.error("Error", "Code Crashed");
      }
   }
   GetMigrationProgress() {

      try {
         this.UTemplates.GetMigrationProgress().subscribe(
            Response => {


               if (Response.status == 200) {



               }
               else {
                  this.noti.error("Error", Response.body);
               }

            },
            err => {
               this.Spinner.hide();
               this.noti.error("Error", err.error);
            }
         );
      } catch (error) {
         this.Spinner.hide();
         this.noti.error("Error", "Code Crashed");
      }
   }
   LoadAllUser(Devid: any) {
      this.dataTable = false;
      this.Spinner.show();
      this.UTemplates.GetUserTemplates(Devid).subscribe(
         Response => {
            this.Spinner.hide();
            if (Response.status == 200) {

               this.UserTemplates = Response.body;

               this.dataTable = true;

            }
         }, error => {
            this.Spinner.hide();
            this.noti.error('Error', error.error);

         });





   }
   MigrateDevice()
   {

    console.clear();
      if (this.selectedDeviceFrom == "" || this.selectedDeviceFrom == null) {
         this.noti.error('Select Device First', "Error");
      }
      else if (this.selectedDeviceTo == "" || this.selectedDeviceTo == null) {
         this.noti.error('Select Device First', "Error");
      }

      else {
         var model = {
            DeviceFrom: this.selectedDeviceFrom,
            DeviceTo: this.selectedDeviceTo,
            UserIDList: this.UserIDList.toString().split(',')
         };

         try {
          this.dataTable=true;
          this.SummaryTogle=false;
            this.Spinner.show();

            this.UTemplates.MigrateUsers(model).subscribe((Response: any) => {
              console.clear();
               this.Spinner.hide();

               if (Response.status == 200) {
                 this.dataTable=false;
                 this.SummaryTogle=true;
                 this.MigrationSummary=Response.body;

                  this.noti.success("Message", "User Successfully transfer");
               }
               else {
                  this.noti.error("Message", Response.body);
               }

            },err=>{
              console.clear();
              this.noti.error(err.error, "Error");
              this.Spinner.hide();
            });

         } catch (error) {

         }
      }


   }

}
